import React from 'react';
import LoadingView from './common/Loading';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import { push } from 'connected-react-router';
import AppNotifications from './common/AppNotifications';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import AppContainer from './common/AppContainer';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import PrivateRoute from './common/PrivateRoute';
import FedrampIdleTimeout from './common/FedrampIdleTimeout';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import Files from './pages/Files';
import urls from '../util/urls';
import pwtUrls from '@lifeomic/phc-web-toolkit/src/util/urls';
import _ from 'lodash';
import asyncPages from './pages/loadablePages';
import MLPages from '@lifeomic/phc-ui-ml/src/pages';
import OmicsExplorerPages from '@lifeomic/phc-ui-omics-explorer/src/pages';
import InsightPages from '@lifeomic/phc-ui-insights/src/pages';
import { projectPickerSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/projectPicker';
import {
  userActions,
  userSelectors,
} from '@lifeomic/phc-web-toolkit/src/redux/modules/user';
import { accountSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/account';
import { evaluatedPolicySelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/evaluatedPolicy';
import { featuresSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/features';
import {
  appSelectors,
  appActions,
} from '@lifeomic/phc-web-toolkit/src/redux/modules/app';
import {
  authActions,
  authSelectors,
} from '@lifeomic/phc-web-toolkit/src/redux/modules/auth';
import { PageLayout } from '@lifeomic/chroma-react/components/PageLayout';
import {
  SecondaryNavigation,
  SecondaryNavigationItem,
} from '@lifeomic/chroma-react/components/SecondaryNavigation';
import { tiles } from '../common/tiles';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import AccountPermissionsDisclaimer from './common/AccountPermissionsDisclaimer';
import { hasFullAccountManagementPrivileges } from '../util/abac';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { getTestProps } from '@lifeomic/phc-web-toolkit/src/util/testProps';
import {
  configSelectors,
  configActions,
} from '@lifeomic/phc-web-toolkit/src/redux/modules/config';
import { BugsnagReportingProvider } from '@lifeomic/phc-web-toolkit/src/util/bugsnagReporting';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import mixpanel from 'mixpanel-browser';
import { WithStyles, withStyles } from '@lifeomic/chroma-react/styles';
import {
  reportErrorToBugsnag,
  reportInfoToBugsnag,
} from '../util/errorReporting/directReporting';
import { ConfigState } from '@lifeomic/phc-web-toolkit/src/redux/modules/config/reducer';
import { AuthProvider, AuthProviderProps, useAuth } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { useDispatch, useSelector } from 'react-redux';
import { AuthRedirect } from './pages/AuthRedirect';
import { Omnibar } from '@lifeomic/phc-web-toolkit/src/components/Omnibar';
import { useRouteSuggestions } from './common/Omnibar/useRouteSuggestions';
import { useSubjectSuggestions } from './common/Omnibar/useSubjectSuggestions';
import { useFeatures } from '@lifeomic/phc-web-toolkit/src/hooks';
import FountainLifeProjectLandingPage from './pages/Projects/LandingPage/ProjectLandingPageFountainLife';
import MemberDetail from './pages/Members/MemberDetail';
import MemberAnnualReport from './pages/Members/MemberDetail/AnnualReport';
import MemberActionPlan from './pages/Members/MemberDetail/ActionPlan';
import MemberAiTools from './pages/Members/MemberDetail/AiTools';
import MemberDocuments from './pages/Members/MemberDetail/Documents';
import MemberLabs from './pages/Members/MemberDetail/Labs';
import MemberOmicsExplorer from './pages/Members/MemberDetail/OmicsExplorer';
import MemberOnboardingSnapshot from './pages/Members/MemberDetail/OnboardingSnapshot';
import MemberSurveys from './pages/Members/MemberDetail/Surveys';

// this is the only place we configure react-hotkeys
// eslint-disable-next-line no-restricted-imports
import { configure } from 'react-hotkeys';

const styles = (theme: any) => ({
  layout: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  left: {
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(0, 4),
  },
  accountName: {
    marginRight: theme.pxToRem(49),
    minWidth: theme.pxToRem(167),
  },
  layoutContainer: {
    padding: theme.spacing(4),
    marginBottom: 0,
    // TS cannot infer the specific set of allowed strings
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    overflowY: 'auto' as 'auto',
  },
});

const AuthenticatedPageLoadingView = () => (
  <Box justify="center" align="center" fullWidth fullHeight>
    <DotLoader size={1} />
  </Box>
);

const manageAccountNav = [
  { item: tiles.manageAccount },
  { item: tiles.features },
  { item: tiles.apiKeys },
  { item: tiles.billing },
  { item: tiles.authClients },
  { item: tiles.usage },
  { item: tiles.groups },
  { item: tiles.manageAccountUsers },
  { item: tiles.accessControl },
  { item: tiles.manageEHRs },
  { item: tiles.educationContent },
  { item: tiles.invitations },
  { item: tiles.createAccount },
  { item: tiles.accountAuditing },
];

// Maintain existing bookmarks
const legacyAccountManagementRedirects = [
  urls.app.apiKeys(),
  urls.app.educationContent(),
  urls.app.usage(),
  urls.app.billing(),
  urls.app.clients(),
  urls.app.manageAccount(),
  urls.app.createAccount(),
  urls.app.createAccount(true),
  urls.app.invitations(),
  urls.app.groups(),
  urls.app.accessControl(),
].map(uri => {
  return {
    // previous uris began with "/account/accounts/", while
    // new uris are simply "/account/"
    legacyUri: uri.replace('/account/', '/account/accounts/'),
    newUri: uri,
  };
});

const {
  AddData,
  EducationContent,
  Logout,
  NotFound,
  UserProfile,
  ManageAccount,
  Features,
  CreateAccount,
  Projects,
  AccountAuditing,
  ProjectSettings,
  PatientDetail,
  Usage,
  Groups,
  Billing,
  ClientsV2,
  Users,
  Tasks,
  GenomicsDashboard,
  TaskView,
  Invitations,
  AccessControl,
  AccessControlV2,
  ApiKeys,
  Home,
  ManageProjects,
  Cohorts,
  GeneSets,
  ProjectTags,
  ManageConsent,
  SurveysList,
  SurveyDetails,
  SurveyResponse,
  Consent,
  ManageCircles,
  ManageEHRs,
  EHRDetail,
  CustomApps,
  GenomicsTests,
  SubjectSearch,
  GenomicsTestDetails,
  GenomicsIngestions,
  GenomicsActions,
  AddGenomicsAction,
  SFTP,
  SFTPUser,
  FileTransfer,
  ProjectLandingPage,
  OntologiesLocalCodeSystems,
  OntologiesLocalCodeSystem,
  OntologiesLocalValueSets,
  OntologiesLocalValueSet,
  OntologiesMarketplaceCodeSystems,
  OntologiesMarketplaceCodeSystem,
  OntologiesMarketplaceValueSets,
  OntologiesMarketplaceValueSet,
  TrialMatching,
  ContentManagement,
  EMAs,
  Marketplace,
  Reseller,
  OnboardingSnapshot,
  ReportTemplates,
  PrintZoriReport,
  ZoomAppointments,
  AIRules,
} = asyncPages;

const {
  ML,
  MLModelDetail,
  MLDatasetDetail,
  MLModelRunDetail,
  MLDatasetExample,
  MLDatasetLabeling,
} = MLPages;
const { Insights } = InsightPages;
const { OmicsExplorer } = OmicsExplorerPages;

const { setAuthFromOIDCFlow } = authActions;
const { loadConfig } = configActions;
const { initializeApp } = appActions;
const { fetchUser } = userActions;

type Props = WithStyles<typeof styles>;

const redirectToHome = () => {
  return <Redirect to={urls.app.home()} />;
};

const App: React.FC<Props> = props => {
  const { classes } = props;
  const dispatch = useDispatch();
  const app = useSelector(appSelectors.selectAppState);
  const auth = useSelector(authSelectors.selectAuthState);
  const OIDCAuth = useAuth();
  const user = useSelector(userSelectors.selectActiveUser);
  const project = useSelector(projectPickerSelectors.selectActiveProject);
  const activeAccount = useSelector(accountSelectors.selectActiveAccount);
  const policy = useSelector(evaluatedPolicySelectors.selectPolicyForUser);
  const features = useSelector(featuresSelectors.selectFeatures);
  const config = useSelector(configSelectors.selectConfigState);
  const hasFeature = useFeatures();

  const ignoreTags = ['input', 'select', 'textarea'];
  const ignoreWithMetaKey = ['c', 'x', 'v', 'a', 'z'];

  configure({
    stopEventPropagationAfterHandling: true,
    allowCombinationSubmatches: false,
    ignoreEventsCondition: keyEvent => {
      const target = keyEvent.target as HTMLElement | undefined;
      const ignoreForTag = !!(
        (target &&
          target.tagName &&
          ignoreTags.includes(target.tagName.toLowerCase())) ||
        target?.contentEditable === 'true' ||
        target?.contentEditable === 'plaintext-only'
      );

      const ignoreForMetaKey =
        keyEvent.metaKey && ignoreWithMetaKey.includes(keyEvent.key);

      return ignoreForMetaKey || ignoreForTag;
    },
  });

  useRouteSuggestions();
  useSubjectSuggestions();

  React.useEffect(() => {
    if (config.oidcAuthEnabled && OIDCAuth.isAuthenticated) {
      dispatch(setAuthFromOIDCFlow(OIDCAuth));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.oidcAuthEnabled, OIDCAuth.isAuthenticated]);

  React.useEffect(() => {
    (async () => {
      await dispatch(initializeApp());
      if (auth.isAuthenticated) {
        await dispatch(fetchUser());
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  const projectName = _.get(project, 'name', '');
  const accountName = _.get(activeAccount, 'name', '');

  mixpanel.init(config.mixpanelToken, { autotrack: false });

  const ProjectLandingPageComponent = hasFeature('fountainLifeUX')
    ? FountainLifeProjectLandingPage
    : ProjectLandingPage;
  return (
    <BugsnagReportingProvider
      reportErrorToBugsnag={reportErrorToBugsnag}
      reportInfoToBugsnag={reportInfoToBugsnag}
    >
      <div style={{ height: '100%' }}>
        {app.initializing ? (
          <LoadingView />
        ) : (
          <Switch>
            <Route
              path={urls.app.login()}
              exact
              component={() => {
                window.location.href = urls.externalApps.login(
                  // Avoid redirect loop after OAuth:
                  `${window.location.origin}/phc`,
                );
                return null;
              }}
            />
            <Route path="/auth/redirect" exact component={AuthRedirect} />
            <Switch>
              <Route path="/" exact render={redirectToHome} />
              <Route
                exact
                path={urls.app.roots.project()}
                render={redirectToHome}
              />
              <Route
                path={urls.app.home()}
                render={() => {
                  return (
                    <AppContainer>
                      <React.Suspense
                        fallback={<AuthenticatedPageLoadingView />}
                      >
                        <PrivateRoute
                          title="Home"
                          intlId="window.title.home"
                          project={projectName}
                          path={urls.app.home()}
                          exact
                          component={Home}
                        />
                      </React.Suspense>
                    </AppContainer>
                  );
                }}
              />
              {legacyAccountManagementRedirects.map((route, i) => (
                <Route
                  key={i}
                  path={route.legacyUri}
                  exact
                  render={() => <Redirect to={route.newUri} />}
                />
              ))}
              <Route
                path={urls.app.roots.accounts()}
                render={() => <Redirect to={urls.app.roots.account()} />}
              />
              <Route
                exact
                path={urls.app.roots.account()}
                render={() =>
                  activeAccount &&
                  tiles.manageAccount.shouldDisplay(activeAccount, policy) ? (
                    // Navigate to manage account if it's available for the user
                    // based on their policy
                    <Redirect to={urls.app.manageAccount()} />
                  ) : activeAccount ? (
                    // The user can navigate to the account management, but
                    // does not have the permissions to view manageAccount.
                    // Determine which account-admin route they *do* have
                    // access to and redirect them there
                    <Redirect
                      to={_.get(
                        manageAccountNav.find(op =>
                          op.item.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          ),
                        ),
                        'item.uri',
                        '',
                      )}
                    />
                  ) : (
                    // They don't have an account, so we send them to
                    // invitations
                    <Redirect to={urls.app.invitations()} />
                  )
                }
              />
              <Route
                path={urls.app.roots.account()}
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      <PageLayout
                        className={classes.layout}
                        leftClassName={classes.left}
                        classes={{
                          layoutContainer: classes.layoutContainer,
                        }}
                        left={
                          <>
                            <Box className={classes.accountName}>
                              {accountName}
                            </Box>
                            {!hasFullAccountManagementPrivileges(policy) &&
                            activeAccount ? (
                              <AccountPermissionsDisclaimer />
                            ) : null}
                          </>
                        }
                        maxWidth={false}
                        sidebar={
                          <SecondaryNavigation>
                            {manageAccountNav
                              .filter(
                                op =>
                                  op.item.uri !== '' &&
                                  op.item.shouldDisplay(
                                    activeAccount,
                                    policy,
                                    features,
                                  ),
                              )
                              .map((op, i) => (
                                <SecondaryNavigationItem
                                  key={i}
                                  to={op.item.uri}
                                  label={op.item.title}
                                  {...getTestProps(
                                    `account-management-item-${op.item.title}`,
                                  )}
                                />
                              ))}
                          </SecondaryNavigation>
                        }
                      >
                        <React.Suspense
                          fallback={<AuthenticatedPageLoadingView />}
                        >
                          <Switch>
                            <PrivateRoute
                              title="Manage Account"
                              intlId="window.title.manage"
                              account={accountName}
                              path={urls.app.manageAccount()}
                              exact
                              authorized={tiles.manageAccount.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={ManageAccount}
                            />
                            <PrivateRoute
                              title="API Keys"
                              intlId="window.title.apiKeys"
                              account={accountName}
                              path={urls.app.apiKeys()}
                              exact
                              policy={policy}
                              enforceAction="apiKeyUser"
                              authorized={tiles.apiKeys.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={ApiKeys}
                            />
                            <PrivateRoute
                              title="Billing"
                              intlId="window.title.billing"
                              account={accountName}
                              path={urls.app.billing()}
                              exact
                              policy={policy}
                              enforceAction="billingAdmin"
                              authorized={tiles.billing.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={Billing}
                            />
                            <PrivateRoute
                              title="Authentication Client"
                              intlId="window.title.clients"
                              account={accountName}
                              path={urls.app.clients()}
                              exact
                              policy={policy}
                              enforceAction="accountAdmin"
                              authorized={tiles.authClients.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={ClientsV2}
                            />
                            <PrivateRoute
                              title="Users"
                              intlId="window.title.users"
                              account={accountName}
                              path={urls.app.manageAccountUsers()}
                              exact
                              policy={policy}
                              enforceAction="accessAdmin"
                              authorized={tiles.manageAccountUsers.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={Users}
                            />
                            <PrivateRoute
                              title="Usage"
                              intlId="window.title.usage"
                              account={accountName}
                              path={urls.app.usage()}
                              exact
                              policy={policy}
                              enforceAction="billingAdmin"
                              authorized={tiles.usage.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              push={push}
                              component={Usage}
                            />
                            <PrivateRoute
                              title="Groups"
                              intlId="window.title.groups"
                              account={accountName}
                              path={urls.app.groups()}
                              exact
                              policy={policy}
                              authorized={tiles.groups.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              push={push}
                              component={Groups}
                            />
                            <PrivateRoute
                              title="Access Control"
                              intlId="window.title.accessControl"
                              path={urls.app.accessControl()}
                              exact
                              policy={policy}
                              enforceAction="accessAdmin"
                              authorized={tiles.accessControl.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={
                                features.accessControlV2
                                  ? AccessControlV2
                                  : AccessControl
                              }
                            />
                            <PrivateRoute
                              title="Features"
                              intlId="window.title.features"
                              path={urls.app.features()}
                              exact
                              policy={policy}
                              enforceAction="accountAdmin"
                              authorized={tiles.features.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={Features}
                            />
                            <PrivateRoute
                              title="EHRs"
                              intlId="window.title.manageEHRs"
                              path={urls.app.ehrs()}
                              exact
                              policy={policy}
                              authorized={tiles.manageEHRs.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={ManageEHRs}
                            />
                            <PrivateRoute
                              title="Account Auditing"
                              intlId="window.title.accountAuditing"
                              path={urls.app.accountAuditing()}
                              exact
                              policy={policy}
                              enforceAction="accountAdmin"
                              authorized={tiles.accountAuditing.shouldDisplay(
                                activeAccount,
                                policy,
                                features,
                              )}
                              component={AccountAuditing}
                            />
                            <PrivateRoute
                              title="EHR"
                              intlId="window.title.manageEHR"
                              path={`${urls.app.ehrs()}/:id`}
                              exact
                              policy={policy}
                              authorized={tiles.manageEHRs.shouldDisplay(
                                activeAccount,
                                policy,
                              )}
                              component={EHRDetail}
                            />
                            <PrivateRoute
                              title="Education Content"
                              intlId="window.title.educationContent"
                              account={accountName}
                              path={urls.app.educationContent()}
                              exact
                              policy={policy}
                              enforceAction="eduContentAdmin"
                              push={push}
                              component={EducationContent}
                            />
                            <PrivateRoute
                              title="Invitations"
                              intlId="window.title.invitations"
                              account={accountName}
                              path={urls.app.invitations()}
                              exact
                              component={Invitations}
                            />
                            <PrivateRoute
                              title="Create Account"
                              intlId="window.title.create"
                              account={accountName}
                              path={urls.app.createAccount()}
                              exact
                              component={CreateAccount}
                            />
                            <PrivateRoute
                              title="Create Test Account"
                              intlId="window.title.create"
                              account={accountName}
                              path={urls.app.createAccount(true)}
                              exact
                              component={CreateAccount}
                            />
                          </Switch>
                        </React.Suspense>
                      </PageLayout>
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <Route
                path={urls.app.manageProjects()}
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      <PrivateRoute
                        title="Home"
                        intlId="window.title.manageProjects"
                        project={projectName}
                        path={urls.app.manageProjects()}
                        exact
                        component={ManageProjects}
                      />
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <Route
                path="/marketplace"
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      <PrivateRoute
                        title="Marketplace"
                        intlId="window.title.marketplace"
                        project={projectName}
                        path={urls.app.marketplace.embedded()}
                        component={Marketplace}
                        exact
                      />
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <Route
                path={urls.app.reseller()}
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      <PrivateRoute
                        title="Reseller"
                        intlId="window.title.reseller"
                        project={projectName}
                        path={urls.app.reseller()}
                        component={Reseller}
                        authorized={tiles.reseller.shouldDisplay(
                          activeAccount,
                          policy,
                        )}
                        exact
                      />
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <Route
                path={urls.app.print.root()}
                render={() => (
                  <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                    <Switch>
                      <PrivateRoute
                        title="Zori Report Print View"
                        intlId="window.title.zoriReportPrintView"
                        project={projectName}
                        path={urls.app.print.zoriReport(':impressionId')}
                        component={PrintZoriReport}
                      />
                    </Switch>
                  </React.Suspense>
                )}
              />
              <Route
                path={urls.app.roots.project()}
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      {activeAccount &&
                        activeAccount.status === 'DEACTIVATED' && (
                          <Redirect to={urls.app.home()} />
                        )}
                      <Switch>
                        <PrivateRoute
                          title="Insights"
                          intlId="window.title.insights"
                          project={projectName}
                          path={urls.app.insights()}
                          exact
                          component={Insights}
                        />
                        <PrivateRoute
                          title="Cohorts"
                          project={projectName}
                          intlId="window.title.cohorts"
                          path={urls.app.cohorts()}
                          exact
                          component={Cohorts}
                        />
                        <PrivateRoute
                          title="Files"
                          project={projectName}
                          intlId="window.title.files"
                          path={urls.app.files()}
                          exact
                          component={Files}
                        />
                        <PrivateRoute
                          title="SFTP"
                          project={projectName}
                          intlId="window.title.sftp"
                          path={urls.app.sftp()}
                          exact
                          component={SFTP}
                        />
                        <PrivateRoute
                          title="File Transfer"
                          project={projectName}
                          intlId="window.title.fileTransfer"
                          path={urls.app.fileTransfer()}
                          exact
                          component={FileTransfer}
                        />
                        <PrivateRoute
                          title="SFTP User"
                          project={projectName}
                          intlId="window.title.sftp.user"
                          path={`${urls.app.sftp()}/:username`}
                          exact
                          component={SFTPUser}
                        />
                        <PrivateRoute
                          title="Tasks"
                          project={projectName}
                          intlId="window.title.tasks"
                          path={urls.app.tasks()}
                          exact
                          component={Tasks}
                        />
                        <PrivateRoute
                          title="Task"
                          project={projectName}
                          intlId="window.title.task"
                          path={`${urls.app.tasks()}/:taskId`}
                          exact
                          component={TaskView}
                        />
                        <PrivateRoute
                          title="Omics"
                          project={projectName}
                          intlId="window.title.omics"
                          path={urls.app.omics.dashboard()}
                          exact
                          component={GenomicsDashboard}
                        />
                        <PrivateRoute
                          title="Omics Tests"
                          project={projectName}
                          intlId="window.title.genomics"
                          path={`${urls.app.omics.tests()}`}
                          exact
                          component={GenomicsTests}
                        />
                        <PrivateRoute
                          title="Omics Test"
                          project={projectName}
                          intlId="window.title.genomics"
                          path={`${urls.app.omics.tests(':testId')}`}
                          exact
                          component={GenomicsTestDetails}
                        />
                        <PrivateRoute
                          title="Omics Ingestions"
                          project={projectName}
                          intlId="window.title.genomicsIngestions"
                          path={urls.app.omics.ingestions()}
                          authorized={tiles.genomicsIngestions.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          exact
                          component={GenomicsIngestions}
                        />
                        <PrivateRoute
                          title="Omics Actions"
                          project={projectName}
                          intlId="window.title.genomicsActions"
                          path={urls.app.omics.actions()}
                          authorized={tiles.genomicsActions.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          exact
                          component={GenomicsActions}
                        />
                        <PrivateRoute
                          title="Add Genomic Action"
                          project={projectName}
                          intlId="window.title.genomicsActions.add"
                          path={urls.app.omics.addActions()}
                          exact
                          authorized={tiles.genomicsActions.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={AddGenomicsAction}
                        />
                        <PrivateRoute
                          title="Projects"
                          intlId="window.title.projects"
                          account={accountName}
                          path={urls.app.projects()}
                          exact
                          component={Projects}
                        />
                        <PrivateRoute
                          title="Project Settings"
                          intlId="window.title.projectSettings"
                          account={accountName}
                          path={urls.app.projectSettings(':projectId')}
                          exact
                          component={ProjectSettings}
                        />
                        <PrivateRoute
                          title="Project"
                          intlId="window.title.projectLandingPage"
                          project={projectName}
                          path={urls.app.projectLandingPage(':projectId')}
                          authorized={features?.projectLandingPage}
                          component={ProjectLandingPageComponent}
                          exact
                        />
                        <PrivateRoute
                          title="Patient Details"
                          intlId="window.title.patient"
                          project={projectName}
                          path={`${urls.app.patients()}/:patientId`}
                          exact
                          component={PatientDetail}
                        />
                        <PrivateRoute
                          title="Project Knowledge"
                          intlId="window.title.projectKnowledge.index"
                          project={projectName}
                          path={urls.app.projectKnowledge('')}
                          exact
                          component={GeneSets}
                        />
                        <PrivateRoute
                          title="Gene Sets"
                          intlId="window.title.projectKnowledge.genesets"
                          project={projectName}
                          path={urls.app.projectKnowledge('gene-sets')}
                          exact
                          component={GeneSets}
                        />
                        <PrivateRoute
                          title="Tags"
                          intlId="window.title.projectKnowledge.tags"
                          project={projectName}
                          path={urls.app.projectKnowledge('tags')}
                          exact
                          component={ProjectTags}
                        />
                        <PrivateRoute
                          title="Consent"
                          project={projectName}
                          intlId="window.title.manageConsent"
                          path={`${urls.app.consentManagement.project()}`}
                          exact
                          authorized={tiles.manageProjectConsent.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={ManageConsent}
                        />
                        <PrivateRoute
                          title="My Consent"
                          project={projectName}
                          intlId="window.title.consent"
                          path={`${urls.app.consent()}`}
                          exact
                          authorized={tiles.consent.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={Consent}
                        />
                        <Route
                          exact
                          intlId="window.title.onboardingSnapshot"
                          path={urls.app.onboardingTracker.root()}
                          authorized={true}
                          render={() => (
                            <Redirect
                              to={urls.app.workflows.onboardingSnapshot()}
                            />
                          )}
                        />
                        <PrivateRoute
                          title="Onboarding Snapshot"
                          intlId="window.title.onboardingSnapshot"
                          project={projectName}
                          path={urls.app.workflows.onboardingSnapshot()}
                          authorized={true}
                          component={OnboardingSnapshot}
                        />
                        <PrivateRoute
                          title="Report Template"
                          intlId="window.title.reportTemplate"
                          project={projectName}
                          path={urls.app.workflows.reportTemplates(
                            ':templateId',
                          )}
                          authorized={tiles.reportTemplates.shouldDisplay(
                            activeAccount,
                          )}
                          component={ReportTemplates}
                        />
                        <PrivateRoute
                          title="Report Templates"
                          intlId="window.title.reportTemplates"
                          project={projectName}
                          path={urls.app.workflows.reportTemplates()}
                          authorized={tiles.reportTemplates.shouldDisplay(
                            activeAccount,
                          )}
                          component={ReportTemplates}
                        />
                        <PrivateRoute
                          title="Zoom Appointments"
                          intlId="window.title.zoomAppointments"
                          path={urls.app.workflows.zoomAppointments()}
                          project={projectName}
                          authorized={true}
                          component={ZoomAppointments}
                        />
                        <PrivateRoute
                          title="Zori Rules"
                          intlId="window.title.zoriRules"
                          path={`${urls.app.workflows.zoriRules()}/:tab?`}
                          project={projectName}
                          authorized={tiles.aiRules.shouldDisplay(
                            activeAccount,
                          )}
                          component={AIRules}
                        />
                        <Route
                          title="Zori Audit"
                          intlId="window.title.zoriAudit"
                          path={urls.app.workflows.zoriAudit()}
                          render={() => (
                            <Redirect
                              to={urls.app.workflows.zoriRules('rule-actions')}
                            />
                          )}
                        />
                        <PrivateRoute
                          title="Manage Circles"
                          project={projectName}
                          intlId="window.title.circles"
                          exact
                          path={`${urls.app.circles()}/:circleId`}
                          component={ManageCircles}
                        />
                        <PrivateRoute
                          title="Manage Circles"
                          project={projectName}
                          intlId="window.title.circles"
                          path={urls.app.circles()}
                          component={ManageCircles}
                        />
                        <PrivateRoute
                          title="Add Data"
                          intlId="window.title.addData"
                          account={accountName}
                          path={urls.app.addData()}
                          exact
                          authorized={tiles.addData.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={AddData}
                        />
                        <PrivateRoute
                          title="Surveys"
                          project={projectName}
                          intlId="window.title.manageSurveys"
                          exact
                          path={pwtUrls.app.manageSurveys()}
                          authorized={tiles.manageSurveys.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={SurveysList}
                        />
                        <PrivateRoute
                          title="Manage Survey"
                          project={projectName}
                          intlId="window.title.manageSurvey"
                          exact
                          path={`${pwtUrls.app.manageSurveys()}/:surveyId`}
                          authorized={tiles.manageSurveys.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={SurveyDetails}
                        />
                        <PrivateRoute
                          title="Survey Response"
                          project={projectName}
                          intlId="window.title.surveyResponse"
                          exact
                          path={pwtUrls.app.surveyResponse()}
                          authorized={tiles.manageSurveys.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={SurveyResponse}
                        />
                        <PrivateRoute
                          title="Custom Apps"
                          intlId="window.title.customApps"
                          account={accountName}
                          path={urls.app.customApps()}
                          exact
                          component={CustomApps}
                        />
                        <PrivateRoute
                          title="Omics Explorer"
                          intlId="window.title.omicsExplorer"
                          project={projectName}
                          path={`${urls.app.omicsExplorer(':subjectId')}`}
                          exact
                          component={OmicsExplorer}
                        />
                        <PrivateRoute
                          title="Subjects"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.patients()}`}
                          exact
                          component={SubjectSearch}
                        />
                        <PrivateRoute
                          title="Members"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members()}`}
                          exact
                          component={SubjectSearch}
                        />
                        <PrivateRoute
                          title="Member Onboarding Snapshot"
                          intlId="window.title.onboardingSnapshot"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/onboarding-snapshot`}
                          exact
                          component={MemberOnboardingSnapshot}
                        />
                        <PrivateRoute
                          title="Member Annual Report"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/annual-report/:annualReportId?/:annualReportSection?`}
                          exact
                          component={MemberAnnualReport}
                        />
                        <PrivateRoute
                          title="Member Action Plan"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(':memberId')}/action-plan`}
                          exact
                          component={MemberActionPlan}
                        />
                        <PrivateRoute
                          title="Member AI Tools"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/ai-tools/:aiToolsSubroute?`}
                          exact
                          component={MemberAiTools}
                        />
                        <PrivateRoute
                          title="Member Labs"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(':memberId')}/labs`}
                          exact
                          component={MemberLabs}
                        />
                        <PrivateRoute
                          title="Member Surveys"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/surveys/:surveysTab?/:responsesTab?`}
                          exact
                          component={MemberSurveys}
                        />
                        <PrivateRoute
                          title="Member Documents"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/documents/:documentsTab?`}
                          exact
                          component={MemberDocuments}
                        />
                        <PrivateRoute
                          title="Member Omics Explorer"
                          intlId="window.title.omicsExplorer"
                          project={projectName}
                          path={`${urls.app.members(
                            ':memberId',
                          )}/omics-explorer`}
                          exact
                          component={MemberOmicsExplorer}
                        />
                        <PrivateRoute
                          title="Member Details"
                          intlId="window.title.subjectSearch"
                          project={projectName}
                          path={`${urls.app.members(':memberId')}`}
                          exact
                          component={MemberDetail}
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.local"
                          path={urls.app.ontologies.local()}
                          project={projectName}
                          component={() => (
                            <Redirect
                              to={urls.app.ontologies.localCodeSystems()}
                            />
                          )}
                          title="Ontologies Local"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.local.codeSystems"
                          path={urls.app.ontologies.localCodeSystems()}
                          project={projectName}
                          component={OntologiesLocalCodeSystems}
                          title="Ontologies Local Code Systems"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.local.codeSystem"
                          path={urls.app.ontologies.localCodeSystem(':id')}
                          project={projectName}
                          component={OntologiesLocalCodeSystem}
                          title="Ontologies Local Code System"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.local.valueSets"
                          path={urls.app.ontologies.localValueSets()}
                          project={projectName}
                          component={OntologiesLocalValueSets}
                          title="Ontologies Local Value Sets"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.local.valueSet"
                          path={urls.app.ontologies.localValueSet(':id')}
                          project={projectName}
                          component={OntologiesLocalValueSet}
                          title="Ontologies Local Value Set"
                        />

                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.marketplace"
                          path={urls.app.ontologies.marketplace()}
                          project={projectName}
                          component={() => (
                            <Redirect
                              to={urls.app.ontologies.marketplaceCodeSystems()}
                            />
                          )}
                          title="Ontologies Marketplace"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.marketplace.codeSystems"
                          path={urls.app.ontologies.marketplaceCodeSystems()}
                          project={projectName}
                          component={OntologiesMarketplaceCodeSystems}
                          title="Ontologies Marketplace Code Systems"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.marketplace.codeSystem"
                          path={urls.app.ontologies.marketplaceCodeSystem(
                            ':id',
                          )}
                          project={projectName}
                          component={OntologiesMarketplaceCodeSystem}
                          title="Ontologies Marketplace Code System"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.marketplace.valueSets"
                          path={urls.app.ontologies.marketplaceValueSets()}
                          project={projectName}
                          component={OntologiesMarketplaceValueSets}
                          title="Ontologies Marketplace Value Sets"
                        />
                        <PrivateRoute
                          exact
                          intlId="window.title.ontologies.marketplace.valueSet"
                          path={urls.app.ontologies.marketplaceValueSet(':id')}
                          project={projectName}
                          component={OntologiesMarketplaceValueSet}
                          title="Ontologies Marketplace Value Set"
                        />
                        <PrivateRoute
                          title="Clinical Trials"
                          intlId="window.title.trialMatching"
                          project={projectName}
                          path={urls.app.trialMatching.root()}
                          authorized={_.get(features, 'trialMatchingV2', false)}
                          component={TrialMatching}
                        />
                        <PrivateRoute
                          title="Machine Learning Labeling"
                          intlId="window.title.mlLabeling"
                          project={projectName}
                          path={urls.app.ml.datasetLabeling(':datasetId')}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={MLDatasetLabeling}
                        />
                        <PrivateRoute
                          title="Machine Learning Example"
                          intlId="window.title.mlExample"
                          project={projectName}
                          path={urls.app.ml.datasetExample(
                            ':datasetId',
                            ':exampleId',
                          )}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={MLDatasetExample}
                        />
                        <PrivateRoute
                          title="Machine Learning Model Run Detail"
                          intlId="window.title.mlModelRunDetail"
                          project={projectName}
                          path={urls.app.ml.modelRunDetail(
                            ':modelId',
                            ':runId',
                          )}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={MLModelRunDetail}
                          exact
                        />
                        <PrivateRoute
                          title="Machine Learning Dataset Detail"
                          intlId="window.title.mlDatasetDetail"
                          project={projectName}
                          path={urls.app.ml.datasetDetail(':datasetId')}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={MLDatasetDetail}
                        />
                        <PrivateRoute
                          title="Machine Learning Model Detail"
                          intlId="window.title.mlModelDetail"
                          project={projectName}
                          path={urls.app.ml.modelDetail(':modelId')}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={MLModelDetail}
                        />
                        <PrivateRoute
                          title="Machine Learning"
                          intlId="window.title.ml"
                          project={projectName}
                          path={urls.app.ml.root()}
                          authorized={tiles.ml.shouldDisplay(
                            activeAccount,
                            policy,
                          )}
                          component={ML}
                        />
                        <PrivateRoute
                          title="Content Management"
                          intlId="window.title.contentManagement"
                          project={projectName}
                          path={urls.app.contentManagement.root()}
                          authorized={_.get(
                            features,
                            'contentManagement',
                            false,
                          )}
                          component={ContentManagement}
                        />
                        <PrivateRoute
                          title="Ecological Momentary Assessments"
                          intlId="window.title.EMAs"
                          project={projectName}
                          path={urls.app.EMAs.root()}
                          authorized={tiles.EMAs.shouldDisplay(
                            activeAccount,
                            policy,
                            features,
                          )}
                          component={EMAs}
                        />
                      </Switch>
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <Route
                path={urls.app.userProfile()}
                render={() => (
                  <AppContainer>
                    <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                      <PrivateRoute
                        title="Profile"
                        intlId="window.title.userProfile"
                        path={urls.app.userProfile()}
                        user={user}
                        exact
                        authorized={auth.isAuthenticated}
                        component={UserProfile}
                      />
                    </React.Suspense>
                  </AppContainer>
                )}
              />
              <React.Suspense fallback={<LoadingView />}>
                <Route exact path={urls.app.logout()} component={Logout} />
              </React.Suspense>
              <React.Suspense fallback={<AuthenticatedPageLoadingView />}>
                <Route path="*" component={NotFound} />
              </React.Suspense>
            </Switch>
          </Switch>
        )}

        <AppNotifications />
        <FedrampIdleTimeout />
        <Omnibar />
      </div>
    </BugsnagReportingProvider>
  );
};

const getOIDCConfig = (config: ConfigState): AuthProviderProps => {
  const oidcIssuer = `${config.appsBaseUri}/oidc-provider`;

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const oidcConfig: AuthProviderProps = {
    authority: `${oidcIssuer}/auth`,
    client_id: config.oauthClientId,
    redirect_uri: config.oidcRedirectUri,
    response_type: 'code',
    response_mode: 'query',
    scope: 'openid offline_access',
    metadata: {
      issuer: oidcIssuer,
      authorization_endpoint: `${oidcIssuer}/auth`,
      token_endpoint: `${oidcIssuer}/token`,
      jwks_uri: `${oidcIssuer}/.well-known/jwks.json`,
    },
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    // The below callback is a requirement from react-oidc-context.
    onSigninCallback: (): void => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  return oidcConfig;
};

const AppWrapper: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const config = useSelector(configSelectors.selectConfigState);
  const OIDCConfig = getOIDCConfig(config);

  React.useEffect(() => {
    dispatch(loadConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // We show the loading state while we retrieve the initial configuration.
  if (_.isEmpty(config)) {
    return <AuthenticatedPageLoadingView />;
  }

  return (
    <AuthProvider {...OIDCConfig}>
      <App {...props} />
    </AuthProvider>
  );
};

export default withRouter<any, any>(withStyles(styles)(React.memo(AppWrapper)));
